import { render } from "./ImagePopOver.vue?vue&type=template&id=db028862&scoped=true"
import script from "./ImagePopOver.vue?vue&type=script&lang=js"
export * from "./ImagePopOver.vue?vue&type=script&lang=js"

import "./ImagePopOver.vue?vue&type=style&index=0&id=db028862&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-db028862"

export default script